import React, { useEffect } from "react";
import { ResidentialUserProfile } from "domains/user-management/views/ResidentialUserProfile/ResidentialUserProfile";
import { useMyResidentialUserProfileModel } from "domains/user-management/models/ResidentialUserProfile/hooks/useMyResidentialUserProfileModel/useMyResidentialUserProfileModel";
import { useModalGroup } from "helpers/hooks/useModalGroup";
import { useLocation } from "react-router";

export const MyResidentialUserProfileController: React.FC<{
  onSaveUserSuccess: () => void;
}> = (props) => {
  const location = useLocation();
  const [activeModal, modalGroupActions] = useModalGroup<"waiverModal">();
  const myResidentialUserProfileModel = useMyResidentialUserProfileModel({
    handleSelectLeaveWithoutWaiver: () => {
      modalGroupActions.openModal("waiverModal");
    },
    onAcceptWaiver() {
      modalGroupActions.closeModal();
    },
    onSaveUserSuccess: props.onSaveUserSuccess,
  });
  const marketOptions = myResidentialUserProfileModel.marketOptions;
  const buildingOptions = myResidentialUserProfileModel.buildingOptions;

  useEffect(() => {
    // Handle provided building param
    const providedBuildingShortCode = location.pathname.substring(11);

    if (
      !!providedBuildingShortCode &&
      marketOptions.length > 0 &&
      !myResidentialUserProfileModel.values.building &&
      !myResidentialUserProfileModel.values.market
    ) {
      myResidentialUserProfileModel.preloadForm(providedBuildingShortCode);
    }
  }, [
    buildingOptions,
    location.pathname,
    marketOptions,
    myResidentialUserProfileModel,
  ]);

  return (
    <ResidentialUserProfile
      errors={myResidentialUserProfileModel.errors}
      enabled={
        myResidentialUserProfileModel.isValid &&
        !myResidentialUserProfileModel.isLoading
      }
      waiverModalIsOpen={activeModal === "waiverModal"}
      loading={myResidentialUserProfileModel.isLoading}
      isValid={myResidentialUserProfileModel.isValid}
      marketOptions={myResidentialUserProfileModel.marketOptions}
      buildingOptions={myResidentialUserProfileModel.buildingOptions}
      buildingUnitOptions={myResidentialUserProfileModel.buildingUnitOptions}
      residentPrivacyPolicyUrl={
        myResidentialUserProfileModel.residentPrivacyPolicyUrl
      }
      residentTermsAndConditionsUrl={
        myResidentialUserProfileModel.residentTermsAndConditionsUrl
      }
      registrationHelp={myResidentialUserProfileModel.registrationHelp}
      deliveryPreferenceSetByBuilding={
        myResidentialUserProfileModel.deliveryPreferenceSetByBuilding
      }
      showPackageDeliveryPreference
      showTCPField
      canToggleDeliveryPreference={
        myResidentialUserProfileModel.canToggleDeliveryPreference
      }
      onChangeMarket={(option): void => {
        myResidentialUserProfileModel.selectMarket(option);
      }}
      onChangeBuilding={(option): void => {
        myResidentialUserProfileModel.selectBuilding(option);
      }}
      onChangeBuildingUnit={(option): void => {
        myResidentialUserProfileModel.selectBuildingUnit(option);
      }}
      onChangeDeliveryPreference={(isLeaveAtDoor: boolean): void => {
        myResidentialUserProfileModel.selectDeliveryPreference(isLeaveAtDoor);
      }}
      onChangeTermsAccepted={(
        event: React.ChangeEvent<HTMLInputElement>,
      ): void => {
        myResidentialUserProfileModel.acceptTerms(event.target.checked);
      }}
      onClickAcceptWaiver={() => {
        myResidentialUserProfileModel.acceptWaiver();
      }}
      onClickCancelWaiver={() => {
        modalGroupActions.closeModal();
      }}
      values={myResidentialUserProfileModel.values}
      handleSubmit={myResidentialUserProfileModel.handleSubmit}
    />
  );
};
